export default __webpack_public_path__ + "static/media/logo-vedi-color.bcc58919.svg";